import { memo, useCallback, useMemo } from 'react';

import { type CustomFieldTypeName } from '@air/api/types';
import { type DropdownMenuOption } from '@air/primitive-dropdown-menu';

import { customFieldIconMap } from '~/constants/customFieldIconMap';
import { CollectionFormField } from './CollectionFormField';

type CustomFieldItemProps = {
  fieldName: string;
  // https://linear.app/air/issue/ENG-112/update-customfielditemprops-to-use-not-use-any
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  onSelect: (fieldId: string, fieldName: string, isRequired: boolean) => Promise<any>;
  // https://linear.app/air/issue/ENG-112/update-customfielditemprops-to-use-not-use-any
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  removeField: (fieldId: string, fieldName: string) => Promise<any>;
  fieldId: string;
  required: boolean;
  fieldTypeName: CustomFieldTypeName;
  disabled?: boolean;
};
export const CustomFieldItem = memo(
  ({ onSelect, fieldName, removeField, fieldId, required, fieldTypeName, disabled }: CustomFieldItemProps) => {
    const ellipsisMenuOptions = useMemo<DropdownMenuOption[]>(
      () => [
        {
          id: 'remove',
          label: 'Remove',
          onSelect: () => removeField(fieldId, fieldName),
          type: 'item',
        },
      ],
      [removeField, fieldId, fieldName],
    );
    const Icon = fieldTypeName ? customFieldIconMap[fieldTypeName] : null;

    const onSelectField = useCallback(
      (isRequired: boolean) => onSelect(fieldId, fieldName, isRequired),
      [fieldId, fieldName, onSelect],
    );

    return (
      <CollectionFormField
        onSelect={onSelectField}
        fieldName={fieldName}
        leftAdornment={Icon && <Icon className="size-4 text-grey-10" />}
        ellipsisMenuOptions={ellipsisMenuOptions}
        required={required}
        disabled={disabled}
      />
    );
  },
);

CustomFieldItem.displayName = 'CustomFieldItem';
